import { FIELDS } from 'modules/cm/domain/Case/Applicant/Income/Current/Current';
import { FormModel } from 'modules/cm/form/Applicant/CurrentIncome/types';

export const FormFields: Record<keyof FormModel, any> = {
  [FIELDS.BASIC_GROSS_ANNUAL_SALARY]: {
    name: FIELDS.BASIC_GROSS_ANNUAL_SALARY,
    label: 'Basic Gross Annual Salary',
  },
  [FIELDS.ANNUAL_BONUS]: {
    name: FIELDS.ANNUAL_BONUS,
    label: 'Annual Bonus',
  },
  [FIELDS.HAS_ANNUAL_BONUS_GUARANTEED]: {
    name: FIELDS.HAS_ANNUAL_BONUS_GUARANTEED,
    label: 'Bonus guaranteed',
  },
  [FIELDS.ANNUAL_COMMISSION]: {
    name: FIELDS.ANNUAL_COMMISSION,
    label: 'Annual Commission',
  },
  [FIELDS.HAS_COMMISSION_GUARANTEED]: {
    name: FIELDS.HAS_COMMISSION_GUARANTEED,
    label: 'Commission guaranteed',
  },
  [FIELDS.ANNUAL_OVERTIME]: {
    name: FIELDS.ANNUAL_OVERTIME,
    label: 'Annual Overtime',
  },
  [FIELDS.HAS_OVERTIME_GUARANTEED]: {
    name: FIELDS.HAS_OVERTIME_GUARANTEED,
    label: 'Overtime guaranteed',
  },
  [FIELDS.ANNUAL_SHIFT_ALLOWANCE]: {
    name: FIELDS.ANNUAL_SHIFT_ALLOWANCE,
    label: 'Annual Shift Allowance',
  },
  [FIELDS.HAS_SHIFT_ALLOWANCE_GUARANTEED]: {
    name: FIELDS.HAS_SHIFT_ALLOWANCE_GUARANTEED,
    label: 'Shift Allowance guaranteed',
  },
  [FIELDS.BUSINESS_TYPE]: {
    name: FIELDS.BUSINESS_TYPE,
    label: 'Business Type',
  },
  [FIELDS.PERCENTAGE_OF_BUSINESS_OWNED]: {
    name: FIELDS.PERCENTAGE_OF_BUSINESS_OWNED,
    label: 'Percentage owned',
  },
  [FIELDS.LIMITED_COMPANY_SALARY]: {
    name: FIELDS.LIMITED_COMPANY_SALARY,
    label: 'Salary',
  },
  [FIELDS.LIMITED_COMPANY_DIVIDENDS]: {
    name: FIELDS.LIMITED_COMPANY_DIVIDENDS,
    label: 'Dividends',
  },
  [FIELDS.NET_PROFIT]: {
    name: FIELDS.NET_PROFIT,
    label: 'Net profit',
  },
  [FIELDS.BUSINESS_TRADING_DATE]: {
    name: FIELDS.BUSINESS_TRADING_DATE,
    label: 'Business Trading Date',
  },

  [FIELDS.INVESTMENT_PREFIX]: (prefix: number) => ({
    [FIELDS.INVESTMENT_PORTFOLIO_VALUE]: {
      name: FIELDS.INVESTMENT_PORTFOLIO_VALUE,
      prefix: `${FIELDS.INVESTMENT_PREFIX}.${prefix}.`,
      label: 'Investment Portfolio Value',
    },
    [FIELDS.INVESTMENT_ANNUAL_INVESTMENT_INCOME]: {
      name: FIELDS.INVESTMENT_ANNUAL_INVESTMENT_INCOME,
      prefix: `${FIELDS.INVESTMENT_PREFIX}.${prefix}.`,
      label: 'Annual Investment Income',
    },
    [FIELDS.INVESTMENT_ANNUAL_DIVIDEND_INCOME]: {
      name: FIELDS.INVESTMENT_ANNUAL_DIVIDEND_INCOME,
      prefix: `${FIELDS.INVESTMENT_PREFIX}.${prefix}.`,
      label: 'Annual Dividend Income',
    },
  }),

  [FIELDS.RENTAL_PREFIX]: (prefix: number) => ({
    [FIELDS.RENTAL_GROSS_ANNUAL_RENTAL_INCOME]: {
      name: FIELDS.RENTAL_GROSS_ANNUAL_RENTAL_INCOME,
      prefix: `${FIELDS.RENTAL_PREFIX}.${prefix}.`,
      label: 'Gross annual rental income',
    },
    [FIELDS.RENTAL_NO_OF_BTLS_IN_PORTFOLIO]: {
      name: FIELDS.RENTAL_NO_OF_BTLS_IN_PORTFOLIO,
      prefix: `${FIELDS.RENTAL_PREFIX}.${prefix}.`,
      label: "No. of BTL's in portfolio",
    },
    [FIELDS.RENTAL_MORTGAGE_PAYMENT]: {
      name: FIELDS.RENTAL_MORTGAGE_PAYMENT,
      prefix: `${FIELDS.RENTAL_PREFIX}.${prefix}.`,
      label: 'Mortgage payment',
    },
  }),

  [FIELDS.FOSTERING_PREFIX]: (prefix: number) => ({
    [FIELDS.FOSTERING_GROSS_ANNUAL_FOSTERING_INCOME]: {
      name: FIELDS.FOSTERING_GROSS_ANNUAL_FOSTERING_INCOME,
      prefix: `${FIELDS.FOSTERING_PREFIX}.${prefix}.`,
      label: 'Gross annual fostering income',
    },
  }),

  [FIELDS.MAINTENANCE_PREFIX]: (prefix: number) => ({
    [FIELDS.MAINTENANCE_GROSS_ANNUAL_MAINTENANCE_INCOME]: {
      name: FIELDS.MAINTENANCE_GROSS_ANNUAL_MAINTENANCE_INCOME,
      prefix: `${FIELDS.MAINTENANCE_PREFIX}.${prefix}.`,
      label: 'Gross annual maintenance income',
    },
    [FIELDS.HAS_MAINTENANCE_GUARANTEED_OTHER_INCOME]: {
      name: FIELDS.HAS_MAINTENANCE_GUARANTEED_OTHER_INCOME,
      prefix: `${FIELDS.MAINTENANCE_PREFIX}.${prefix}.`,
      label: 'Maintenance guaranteed',
    },
  }),

  [FIELDS.BENEFIT_PREFIX]: (prefix: number) => ({
    [FIELDS.BENEFIT_GROSS_ANNUAL_BENEFIT_INCOME]: {
      name: FIELDS.BENEFIT_GROSS_ANNUAL_BENEFIT_INCOME,
      prefix: `${FIELDS.BENEFIT_PREFIX}.${prefix}.`,
      label: 'Gross annual benefit income',
    },
    [FIELDS.HAS_BENEFIT_GUARANTEED_OTHER_INCOME]: {
      name: FIELDS.HAS_BENEFIT_GUARANTEED_OTHER_INCOME,
      prefix: `${FIELDS.BENEFIT_PREFIX}.${prefix}.`,
      label: 'Benefit guaranteed',
    },
  }),

  [FIELDS.OTHER_PREFIX]: (prefix: number) => ({
    [FIELDS.OTHER_GROSS_ANNUAL_OTHER_INCOME]: {
      name: FIELDS.OTHER_GROSS_ANNUAL_OTHER_INCOME,
      prefix: `${FIELDS.OTHER_PREFIX}.${prefix}.`,
      label: 'Gross annual other income',
    },
    [FIELDS.OTHER_HAS_BONUS_GUARANTEED_OTHER_INCOME]: {
      name: FIELDS.OTHER_HAS_BONUS_GUARANTEED_OTHER_INCOME,
      prefix: `${FIELDS.OTHER_PREFIX}.${prefix}.`,
      label: 'Other guaranteed',
    },
  }),
};
